import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from '../../../environments/environment';

// Fake JWT payload: { exp: 9999999999 }  — never expires in practice
const DEV_TOKEN = 'eyJhbGciOiJub25lIn0.eyJleHAiOjk5OTk5OTk5OTl9.dev';

function injectDevSession(auth: AuthenticationService): void {
  if (sessionStorage.getItem('current-username')) return;
  sessionStorage.setItem('current-username', 'Dev User');
  sessionStorage.setItem('current-email', 'dev@localhost.com');
  sessionStorage.setItem('current-role', 'admin');
  sessionStorage.setItem('id-token', DEV_TOKEN);
  auth.currentUserName$.next('Dev User');
}

export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  if (!environment.production && globalThis.location.hostname === 'localhost') {
    injectDevSession(auth);
    return true;
  }

  const isLoggedIn = !!auth.currentUserName$.value || !!sessionStorage.getItem('current-username');
  if (isLoggedIn) {
    if (auth.isBackendTokenExpired()) {
      auth.logout();
      router.navigate(['/login'], { queryParams: { expired: true } });
      return false;
    }
    return true;
  }
  router.navigate(['/login']);
  return false;
};
